import APIService from '../api.service';

export const List = (params) => {
    return APIService.get(`/v01/production-orders`, {
        params: {
            per_page: params.per_page,
            page: params.page,
            keyword: params.keyword,
            status: params.status,
            date: params.date,
            date_from: params.date_from,
            date_to: params.date_to,
            sort_by: params.sort_by,
            sort_order: params.sort_order,
            finished_good_id: params.finished_good_id,
            raw_material_id: params.raw_material_id,
        },
    });
};

export const Create = (body, config = {}) => {
    return APIService.post(`/v01/production-orders`, body, config);
};

export const Update = (id, payload, config = {}) => {
    return APIService.put(`/v01/production-orders/${id}`, { ...payload }, config);
};

export const Show = (id, config = {}) => {
    return APIService.get(`/v01/production-orders/${id}`, config);
};

export const Delete = (id, config = {}) => {
    return APIService.delete(`/v01/production-orders/${id}`, config);
};

const ProductionOrderService = {
    List,
    Create,
    Update,
    Show,
    Delete,
};

export default ProductionOrderService;
